import styled from "styled-components";
import color from "../../assets/css/colors";

export const Column = styled.div`
    width: 284px;
    margin-right: 70px;

    #btn-submit {
        padding: 8px;
        font-size: 0.9em;
    }

    @media (max-width: 500px){
        width: 100%;
        margin-right: 0px;
    }
`;

export const Legend = styled.legend`
    font: normal normal normal 14px Circular Std Book;
    color: ${color.tertiary};
    margin-bottom: 28px;
`;